import React, { useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Logo from './img/logo'
import './toast.css';
import './App.css';

import Form from './form';
import { connect } from 'react-redux';

export let container

function App() {


  return (<>
    <ToastContainer
      position="bottom-center"
      autoClose={3000}
      hideProgressBar={true}
      newestOnTop={false}
      closeOnClick
      rtl
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="colored"
    />
    <span id="top" />
    <div className="landing_frame">
      <div className='container'>
        <div className='logo_wrapper'>
          <Logo />
          <div>
            <h1>غصن البان للرجيم والرشاقة</h1>
            <h2>تحت إشراف الدكتور محمد الكــرماني</h2>
          </div>
        </div>
        <Form />
      </div>
    </div>
  </>);
}

export default App
